export default function ({ app, store, $axios }) {
    // onLanguageSwitched called right after a new locale has been set
    app.i18n.beforeLanguageSwitch = (oldLocale, newLocale) => {
        $axios.setHeader("Accept-Language", newLocale);
        store.commit("globalvars/setLanguage", newLocale);
        document.querySelector("html").classList.add("langChange");
        setTimeout(() => {
            document.querySelector("html").classList.remove("langChange");
        }, 400);
    };
    app.i18n.onLanguageSwitched = async (oldLocale, newLocale) => {
        store.commit("globalvars/setLanguage", newLocale);
        await store.dispatch("globalvars/getLanguagesAndCurrencies");
        await store.dispatch("collections/init");
    };
}
